module.exports = __webpack_public_path__ + "static/img/jisoo3.e383663.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jisoo3.jpg
// module id = /MKj
// module chunks = 9